import equals from 'fast-deep-equal';
import { createSelectors } from '@leverege/ui-redux';
import Constants from '../Constants.js';
const initialState = {
  // resourceId :
  //   status : 'loading'
  //   resourceEnums :
  //     type :
  //       status :
  //       ...enum data
};
function createState(curr) {
  if (curr == null) {
    return {
      status: null,
      resourceEnums: {}
    };
  }
  return {
    resourceEnums: {},
    ...curr
  };
}
function copyEnums(curr, ensureType) {
  const n = {
    ...(curr || {})
  };
  if (ensureType) {
    n[ensureType] = {
      ...(curr[ensureType] || {})
    };
  }
  return n;
}
function mergeValues(newData, values = []) {
  const nValues = [...values];
  const {
    offset,
    items
  } = newData;
  for (let i = 0; i < items.length; i++) {
    nValues[i + parseInt(offset)] = items[i];
  }
  return nValues;
}

// eslint-disable-next-line default-param-last
function resourceEnums(state = initialState, action) {
  switch (action.type) {
    case Constants.RESOURCE_ENUM_STATUS:
      {
        const {
          resourceId,
          status,
          error = null,
          enumType
        } = action;
        const nState = {
          ...state
        };
        nState[resourceId] = createState(state[resourceId]);
        if (enumType == null) {
          nState[resourceId].status = status;
          nState[resourceId].error = error;
        } else {
          nState[resourceId].resourceEnums = copyEnums(nState[resourceId].resourceEnums, enumType);
          nState[resourceId].resourceEnums[enumType].status = status;
          nState[resourceId].resourceEnums[enumType].error = error;
        }
        return nState;
      }
    case Constants.RESOURCE_ENUM_ADD:
      {
        const {
          resourceId,
          data
        } = action;
        const nState = {
          ...state
        };
        nState[resourceId] = createState(state[resourceId]);
        nState[resourceId].resourceEnums = copyEnums(nState[resourceId].resourceEnums);
        nState[resourceId].resourceEnums[data.type] = data;
        return nState;
      }
    case Constants.RESOURCE_ENUM_LIST:
      {
        const {
          resourceId,
          list
        } = action;
        const nState = {
          ...state
        };
        nState[resourceId] = createState(state[resourceId]);
        nState[resourceId].resourceEnums = {}; // TODO: Handle paginated lists
        if (list) {
          list.forEach(e => {
            nState[resourceId].resourceEnums[e.type] = e;
          });
        }
        return nState;
      }
    case Constants.RESOURCE_ENUM_DELETE_ALL:
      {
        const nState = {
          ...state
        };
        // TODO: Handle multiple projects
        Object.keys(nState).forEach(id => {
          nState[id].resourceEnums = {};
        });
        return nState;
      }
    case Constants.RESOURCE_ENUM_VALUES:
      {
        const {
          resourceId,
          data,
          enumType,
          isResourceLevel
        } = action;
        const nState = {
          ...state
        };
        nState[resourceId] = createState(state[resourceId]);
        nState[resourceId].resourceEnums = copyEnums(nState[resourceId].resourceEnums, enumType);
        const original = nState[resourceId].resourceEnums[enumType];
        nState[resourceId].resourceEnums[enumType].values = mergeValues(data, nState[resourceId].resourceEnums[enumType].values);
        if (!isResourceLevel) {
          // update enums for all resources
          Object.keys(nState).forEach(id => {
            if (id !== resourceId) {
              nState[id].resourceEnums = copyEnums(nState[id].resourceEnums, enumType);
              if (!nState[id].resourceEnums[enumType] || equals(original, nState[id].resourceEnums[enumType])) {
                nState[id].resourceEnums[enumType].values = mergeValues(data, nState[id].resourceEnums[enumType].values);
              }
            }
          });
        }
        return nState;
      }
    case Constants.RESOURCE_ENUM_RESET_VALUES:
    case Constants.RESOURCE_ENUM_UPDATE_VALUE:
    case Constants.RESOURCE_ENUM_ADD_VALUE:
    case Constants.RESOURCE_ENUM_REMOVE_VALUE:
    case Constants.RESOURCE_ENUM_UPDATE:
    case Constants.RESOURCE_ENUM_GET:
      {
        const {
          resourceId,
          isResourceLevel,
          enumType,
          data
        } = action;
        const nState = {
          ...state
        };
        nState[resourceId] = createState(state[resourceId]);
        nState[resourceId].resourceEnums = copyEnums(nState[resourceId].resourceEnums, enumType);
        const original = nState[resourceId].resourceEnums[enumType];
        nState[resourceId].resourceEnums[enumType] = data;
        if (!isResourceLevel) {
          // update enums for all resources
          Object.keys(nState).forEach(id => {
            if (id !== resourceId) {
              nState[id].resourceEnums = copyEnums(nState[id].resourceEnums, enumType);
              if (!nState[id].resourceEnums[enumType] || equals(original, nState[id].resourceEnums[enumType])) {
                nState[id].resourceEnums[enumType] = data;
              }
            }
          });
        }
        return nState;
      }
    case Constants.RESOURCE_ENUM_REMOVE:
      {
        const {
          resourceId,
          isResourceLevel,
          enumType
        } = action;
        const nState = {
          ...state
        };
        // !TODO handle cases where project defined enum is 'removed' via Resource -- will reset to default on next get
        nState[resourceId] = createState(state[resourceId]);
        nState[resourceId].resourceEnums = copyEnums(nState[resourceId].resourceEnums, enumType);
        delete nState[resourceId].resourceEnums[enumType];
        if (!isResourceLevel) {
          // update enums for all resources
          Object.keys(nState).forEach(id => {
            if (id !== resourceId) {
              nState[id].resourceEnums = copyEnums(nState[id].resourceEnums, enumType);
              delete nState[id].resourceEnums[enumType];
            }
          });
        }
        return nState;
      }
    default:
      {
        return state;
      }
  }
}
function getStatus(state, resourceId, type) {
  const rsrcId = resourceId || process?.env?.projectId;
  if (type == null) {
    if (state && state[rsrcId]) {
      return state[rsrcId].status;
    }
    return null;
  }
  if (state && state[rsrcId] && state[rsrcId].resourceEnums && state[rsrcId].resourceEnums[type]) {
    return state[rsrcId].resourceEnums[type].status;
  }
  return null;
}
function getError(state, resourceId, type) {
  const rsrcId = resourceId || process?.env?.projectId;
  if (type == null) {
    if (state && state[rsrcId]) {
      return state[rsrcId].error;
    }
    return null;
  }
  if (state && state[rsrcId] && state[rsrcId].resourceEnums && state[rsrcId].resourceEnums[type]) {
    return state[rsrcId].resourceEnums[type].error;
  }
  return null;
}
function getResourceEnum(state, resourceId, type) {
  const rsrcId = resourceId || process?.env?.projectId;
  if (state && state[rsrcId] && state[rsrcId].resourceEnums && state[rsrcId].resourceEnums[type]) {
    return state[rsrcId].resourceEnums[type];
  }
  return null;
}
function getResourceEnums(state, resourceId) {
  const rsrcId = resourceId || process?.env?.projectId;
  if (state && state[rsrcId] && state[rsrcId].resourceEnums) {
    return state[rsrcId].resourceEnums;
  }
  return {};
}
resourceEnums.getStatus = getStatus;
resourceEnums.getError = getError;
resourceEnums.getResourceEnums = getResourceEnums;
resourceEnums.getResourceEnum = getResourceEnum;
resourceEnums.createSelectors = (key, createSetStateKey = false) => {
  return createSelectors(key, {
    getStatus,
    getError,
    getResourceEnum,
    getResourceEnums
  }, createSetStateKey);
};
const selectors = resourceEnums.createSelectors('resourceEnums', true);
Object.keys(selectors).forEach(key => {
  resourceEnums[key] = selectors[key];
});
export default resourceEnums;